/* eslint global-require: "off" */
import { merge } from 'lodash';

export default {
  ...merge(
    {
      attributes: {
        code: 'code',
        name: 'nom',
        email: 'courriel',
        password: 'mot de passe',
        created_at: 'date de création',
        updated_at: 'date de dernière modification',
        deleted_at: 'date de supression',
      },
    },
    require('./version').default,
  ),
};
